import {Button, Col, Form, Row, Space, Table} from "antd";
import {InputFields, ModalCustom, Notification} from "components/common";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {columnsFunc, fields} from "./config";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import {authenticationService} from "api";
import {listMenu} from "data/list";
import {useAppSelector} from "redux/hooks";
import {toNumber} from "helper/common";
import ModalRoleTab from "./ModalRoleTab/ModalRoleTab";
const ModalRoleMenu = forwardRef((props: any, ref) => {
  const {dataMenu, getListMenuByRole, selectedRoleId} = props;
  const modalRoleTabRef = useRef<any>();
  const childRoleTabRef = useRef<any>();
  const [form] = Form.useForm<{name: string; listRole: any[]}>();
  const [total, setTotal] = useState(0);
  const [params, setParams] = useState({page: 1, limit: 10});
  const handlePaginationChange = (page, pageSize?: number) => {
    setParams({...params, page: page, limit: pageSize});
  };
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const [data, setData] = useState<any>([]);
  useEffect(() => {
    setData(listMenu.map(e => ({key: e?.value, menu: e?.label})));
  }, []);

  const paginationConfig = {
    // trang hiện tại
    total: total, // tổng số phần tử
    // pageSize: limit,
    onChange: handlePaginationChange,
  };
  useImperativeHandle(ref, () => ({
    resetFields: () => {
      form.resetFields();
      setSelectedRowKeys([]);
    },
  }));
  const addMenuToRole = async () => {
    try {
      const params = selectedRowKeys.map(e => ({
        roleId: selectedRoleId,
        menu: e,
      }));
      const res = await authenticationService.addMenuToRoleAlina(params);
      getListMenuByRole(selectedRoleId);
      Notification("success", "Đã thêm thành công");
    } catch (error) {
      Notification("eror", "Đã xảy ra lỗi");
    }
  };
  const onRowSelect = (selectedRowKeys, selectedRows, info) => {
    setSelectedRowKeys(selectedRowKeys);
  };
  return (
    <div>
      <Form form={form}>
        {/* <Row gutter={[4, 4]} style={{marginBottom: 4}}>
          <InputFields data={fields}></InputFields>
          <Col>
            <Button type="primary">Tìm kiếm</Button>
          </Col>
        </Row> */}
        <CustomResizableTable
          //   setShowColumns={setShowColumns}
          bordered
          dataSource={data}
          columns={columnsFunc}
          // className="custom-resize-table-scroll"
          // scroll={{x: 2500}}

          rowSelection={{
            selectedRowKeys: selectedRowKeys,
            type: "checkbox",
            onChange: onRowSelect,
            getCheckboxProps: (record: any) => ({
              disabled: dataMenu?.some(
                exisMenu => exisMenu?.menu == record?.key
              ), // Column configuration not to be checked
            }),
          }}
          pagination={paginationConfig}
        />
        <ModalCustom
          onOpenModal={() => {
            childRoleTabRef?.current?.getListTabByRole();
          }}
          draggable
          width={500}
          ref={modalRoleTabRef}
          title={`Phân quyền tab`}
        >
          <ModalRoleTab
            selectedRoleId={selectedRoleId}
            ref={childRoleTabRef}
            dataMenu={dataMenu}
          ></ModalRoleTab>
        </ModalCustom>
        <Row justify={"end"} style={{marginTop: 4}}>
          <Space>
            <Button
              className="btn-sub"
              onClick={() => {
                modalRoleTabRef?.current?.openModal();
              }}
              disabled={toNumber(dataMenu?.length) == 0}
            >
              Chọn tab
            </Button>
            <Button type="primary" onClick={addMenuToRole}>
              Lưu
            </Button>
          </Space>
        </Row>
      </Form>

      <div></div>
    </div>
  );
});

export default ModalRoleMenu;
